import ScrollReveal from "../../../components/feature/ScrollReveal";
import { accessInfo } from "../../../mocks/accessData";

export default function AccessSection() {
  return (
    <section className="py-16 md:py-24 bg-airdoa-white">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-10">
              <p className="section-label mb-3">{accessInfo.label}</p>
              <h2 className="section-title">{accessInfo.title}</h2>
            </div>
          </ScrollReveal>

          <ScrollReveal direction="up" delay={100}>
            <div className="p-5 bg-airdoa-cream rounded-lg mb-8">
              <p className="text-xs text-airdoa-gray mb-1">{accessInfo.address.label}</p>
              <p className="text-base font-medium text-airdoa-navy">{accessInfo.address.value}</p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {accessInfo.methods.map((method, idx) => (
              <ScrollReveal key={method.type} direction="up" delay={idx * 100}>
                <div className="p-5 bg-white border border-airdoa-gray-light/50 rounded-lg h-full">
                  <div className="w-10 h-10 flex items-center justify-center text-airdoa-gold mb-4">
                    <i className={`ri-${method.type === "train" ? "subway-line" : method.type === "car" ? "car-line" : "taxi-line"} text-xl`} />
                  </div>
                  <h3 className="text-base font-serif font-semibold text-airdoa-navy">{method.title}</h3>
                  <p className="mt-2 text-sm text-airdoa-gray leading-relaxed">{method.desc}</p>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}